import type { ICommonState } from './types'

export const initialState: ICommonState = {
  drawerVisible: false,
}
